import { makeStyles } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";


export default makeStyles((theme) => ({
  emailField:{
    marginBottom:10
  },
  adornment: {
    padding: 0,
    margin: 0,
    cursor: "pointer",
  }
}));


export const getMuiTheme = (theme) => {
  return createMuiTheme({
    ...theme,
    overrides: {
      MuiInputAdornment: {
        positionStart: {
            color:"#ccc",
            padding: 0,
            margin: 0,
            cursor: "pointer",
        },
      },
    },
  });
}
